import { render, staticRenderFns } from "./base-price-port-config-list.vue?vue&type=template&id=6c94b834&scoped=true&"
import script from "./base-price-port-config-list.vue?vue&type=script&lang=js&"
export * from "./base-price-port-config-list.vue?vue&type=script&lang=js&"
import style0 from "./base-price-port-config-list.vue?vue&type=style&index=0&id=6c94b834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c94b834",
  null
  
)

export default component.exports